export default __webpack_public_path__ + "static/media/myCollection.b7e740c7.svg";